import { render, staticRenderFns } from "./SvgQuadBackground.vue?vue&type=template&id=85d2cf2c&"
import script from "./SvgQuadBackground.vue?vue&type=script&lang=js&"
export * from "./SvgQuadBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports